(function IIFE() {
    'use strict';

    /////////////////////////////

    function WidgetProcessMakerDirective() {
        'ngInject';

        function WidgetProcessMakerLink(scope, el, attrs, ctrls) {
            ctrls[0].setParentController(ctrls[1]);
        }

        return {
            bindToController: true,
            controller: 'WidgetIframeController',
            controllerAs: 'vm',
            link: WidgetProcessMakerLink,
            replace: true,
            require: ['widgetProcessMaker', '^widget'],
            restrict: 'E',
            scope: {
                widget: '<',
            },
            // eslint-disable-next-line max-len
            templateUrl: '/client/front-office/modules/content/modules/widget/modules/widget-process-maker/views/widget-process-maker.html',
        };
    }

    /////////////////////////////

    angular.module('Widgets').directive('widgetProcessMaker', WidgetProcessMakerDirective);
})();
